import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { useSearchParams } from 'react-router-dom';

import Intercom from '@intercom/messenger-js-sdk';
import { useAuthStore } from 'src/entities/user/store/useAuthStore';
import { ROUTE_PATHS } from 'src/shared/config/routes';

import * as Analytics from '../../services/analytics/analytics';
import { analyticsService } from '../../services/analytics/analyticsService';

const PrivateRoute = () => {
  const [searchParams] = useSearchParams();
  const authTokenQuery = searchParams.get('auth_token');
  const authToken = useAuthStore((state) => state.authToken);
  const user = useAuthStore((state) => state.user);

  const { pathname } = useLocation();

  useEffect(() => {
    Analytics.trackPageView(pathname);
  }, [pathname]);

  useEffect(() => {
    Analytics.init({ userInfo: user });
    analyticsService.initProvider({ userInfo: user });
  }, [user]);

  useEffect(() => {
    if (user) {
      Intercom({
        app_id: 'ouv4eyd2',
        user_id: user.id.toString(),
        name: user.username,
        email: user.email
      });
    }
  }, [user]);

  if (authTokenQuery) {
    return <Outlet />;
  }

  if (!authToken) {
    return <Navigate to={ROUTE_PATHS.LOGIN} replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
